import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
  SkeletonTextBlock,
} from '@/components/common/skeleton';

/**
 * Mirrors the real list geometry (hero: GlassCard r16/p20 gap12; rows:
 * GlassCard r12/p14 with a two-line body) so content lands without a jump.
 */
export const MobileMaintenanceSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Hero card placeholder */}
    <SkeletonCard padding={20} borderRadius={16} style={styles.heroCard}>
      <View style={styles.cardHeader}>
        <SkeletonBone width={90} height={14} borderRadius={7} />
        <SkeletonBone width={64} height={12} />
      </View>
      <SkeletonBone width="80%" height={18} />
      <View style={styles.metaRow}>
        <SkeletonBone width={44} height={44} borderRadius={8} />
        <SkeletonTextBlock lines={2} lineHeight={12} lastLineWidth="40%" />
      </View>
      {/* Horizontal timeline: rail + three milestone labels */}
      <View style={styles.timeline}>
        <SkeletonBone width="100%" height={10} borderRadius={5} />
        <View style={styles.timelineLabels}>
          <SkeletonBone width={56} height={10} />
          <SkeletonBone width={56} height={10} />
          <SkeletonBone width={56} height={10} />
        </View>
      </View>
    </SkeletonCard>

    {/* Compact two-line row placeholders */}
    <SkeletonList count={2} gap={12}>
      <SkeletonCard padding={14} borderRadius={12}>
        <View style={styles.rowLine}>
          <SkeletonBone width={8} height={8} borderRadius={4} />
          <View style={styles.rowBody}>
            <SkeletonBone width="60%" height={16} />
            <SkeletonBone width="40%" height={12} />
          </View>
          <SkeletonBone width={14} height={14} />
        </View>
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: { gap: 16 },
  heroCard: { gap: 12 },
  cardHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  metaRow: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  timeline: { gap: 6 },
  timelineLabels: { flexDirection: 'row', justifyContent: 'space-between' },
  rowLine: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  rowBody: { flex: 1, gap: 6 },
});
